import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import React from "react";

import { cn } from "../cn";

export const badgeVariants = cva(
  [
    "tw-inline-flex tw-w-fit tw-shrink-0 tw-items-center tw-justify-center tw-gap-1 tw-overflow-hidden tw-rounded-md tw-border tw-border-solid",
    "tw-px-2.5 tw-py-0.5 tw-font-sans tw-text-xs tw-font-medium tw-leading-normal tw-transition-colors",
    "[&>svg]:tw-pointer-events-none [&>svg]:tw-size-3",
  ],
  {
    variants: {
      variant: {
        default: "tw-border-transparent tw-bg-primary tw-text-primary-foreground",
        secondary: "tw-border-transparent tw-bg-secondary tw-text-secondary-foreground",
        destructive: "tw-border-transparent tw-bg-destructive tw-text-destructive-foreground",
        outline: "tw-border-border tw-text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export type BadgeProps = React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean };

export function Badge({ className, variant = "default", asChild = false, ...props }: BadgeProps) {
  const Comp = asChild ? Slot : "span";
  return <Comp data-slot="badge" data-variant={variant} className={cn(badgeVariants({ variant }), className)} {...props} />;
}
